const sortSettings = (settings = {}) =>
    Object.entries(settings)
        .sort(([keyA, a], [keyB, b]) => {
            const aDeleted = true === a.deleted;
            const bDeleted = true === b.deleted;

            // Placer les éléments supprimés à la fin
            if (aDeleted !== bDeleted) { return aDeleted ? 1 : -1; }

            // Si tous les deux (ou aucun) sont supprimés, tri alphabétique
            const nameA = keyA.toLowerCase();
            const nameB = keyB.toLowerCase();

            if (nameA > nameB) { return 1; }
            if (nameA < nameB) { return -1; }

            return 0;
        });

export default sortSettings;
